import getInstance from "../config/api";

export default class Partner {
  static async fetchPartners() {
    const instance = getInstance();
    const { data } = await instance.get("/bank");
    return data;
  }
  static async fetchPartnerById(id) {
    const instance = getInstance();
    const { data } = await instance.get(`/bank/${id}`);
    return data;
  }
  static async updatePartner(id, body) {
    const instance = getInstance();
    const { data } = await instance.put(`/bank/${id}`, body);
    return data;
  }
  static async deletePartner(id) {
    const instance = getInstance();
    const { data } = await instance.delete(`/bank/${id}`);
    return data;
  }
  static async createPartner(body) {
    const instance = getInstance();
    const { data } = await instance.post("/bank", body);
    return data;
  }
  static async togglePartner(id) {
    const instance = getInstance();
    const { data } = await instance.put(`/bank/toggle-active/${id}`);
    return data;
  }
}
